import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainContainer = styled.div`
  margin: 4rem 12rem;
  width: 100%;
  
  @media (max-width: 800px) {
    margin: 4rem 6rem;
  }
  
  @media (max-width: 600px) {
    margin: 4rem 3.5rem;
  }
`;

const ContentWrapper = ({children}) => {
  return (
    <MainContainer>
      {children}
    </MainContainer>
  );
};

ContentWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default ContentWrapper;
